export const M_Logger_DefaultScopeData = {
	info: false,
	warning: false,
	error: false,
};
